import styled from 'styled-components';

export const Image = styled.img`
  max-width: 914px;
`;

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  max-width: 100%;
  max-height: 528px;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);

  &:after {
    content: '';
    top: 0;
    left: 50%;
    width: 992px;
    height: 528px;
    position: absolute;
    border: 1px solid #f8f8f8;
    background-color: transparent;
    pointer-events: none;
    transform: translateX(-50%);
  }

  video,
  img {
    height: 100%;
    max-width: 100%;
  }
  img {
    padding: 0 150px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step3/styled.js